import { render, staticRenderFns } from "./PasswordChangeForm.vue?vue&type=template&id=adb0321c&scoped=true&"
import script from "./PasswordChangeForm.vue?vue&type=script&lang=js&"
export * from "./PasswordChangeForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordChangeForm.vue?vue&type=style&index=0&id=adb0321c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb0321c",
  null
  
)

export default component.exports